module.exports = __webpack_public_path__ + "static/img/y-3.7ae7d74c.png";